import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { purchaseViewAction } from "../../../redux/actions/purchase-action";
import CreateEditViewPur from "../../../components/purchase-section/purchase-order/create-edit-view-pur";
const ViewPurchase = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(purchaseViewAction(id, onSuccPur, onErrPur));
  }, []);
  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };
  const onErrPur = (data) => {
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="Purchase order View">
          <CreateEditViewPur
            // <CreateEditViewPurchase
            payto={orderDetail?.orderData?.pot_pay_to_address}
            shipto={orderDetail?.orderData?.pot_ship_to_address}
            pageType="purchase"
            page="view"
            disabled={true}
            type="purchase"
            data={orderDetail}
            orderDetail={orderDetail?.itemData}
            vendorDetails={[orderDetail?.orderData]}
            toValidate={false}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default ViewPurchase;
